export const isNumeric = (value: string) =>
  !isNaN(value as any) && !isNaN(parseInt(value))
